import { render, staticRenderFns } from "./b3.vue?vue&type=template&id=310afd72&scoped=true&"
import script from "./b3.vue?vue&type=script&lang=js&"
export * from "./b3.vue?vue&type=script&lang=js&"
import style0 from "./b3.vue?vue&type=style&index=0&id=310afd72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310afd72",
  null
  
)

export default component.exports